import React from 'react';
import {t} from "../../../components/Translate";
import AddIcon from '../../../assets/img/add.png';
import ImportIcon from '../../../assets/img/import.png';
import ExportIcon from '../../../assets/img/export.png';
import DeleteAllIcon from '../../../assets/img/delete-all.png';
import OverviewIcon from '../../../assets/img/overview.png';
import PublishIcon from '../../../assets/img/yes.png';
import CancelIcon from '../../../assets/img/no.png';
import Tooltip from "../../../components/Tooltip";
import {toast} from "react-toastify";

const ResourcesButtons = ({
                              toggleFormVisibility,
                              handleImportClick,
                              openModal,
                              tempResources,
                              publishResourcesCall,
                              deleteTempResourcesList,
                              showChanges,
                              user,
                              config,
                              currentUser,
                              openExportModal,
                              openConfirmModal,
                              setConfirmModalAction
                          }) => {
    const {role} = user.data;
    const isManager = role === config.roles.manager;

    return (
        <div
            className="resources-buttons-parent-div"
            style={{display: 'flex', gap: '35px'}}
        >
            <div style={{
                height: '40px',
                alignItems: 'center',
                padding: '0 14px 0 14px',
                borderRadius: '15px',
                display: 'flex',
                gap: '35px',
                marginBottom: '20px',
                background: '#f1f3f5',
                opacity: isManager ? 1 : 0.5,
                pointerEvents: isManager ? 'auto' : 'none',
            }}>
                <Tooltip text={t(currentUser.language, "add")}>
                    <img
                        style={{cursor: 'pointer'}}
                        onClick={isManager ? toggleFormVisibility : () => {
                            toast.error(t(currentUser.language, 'error'), {
                                position: "top-right",
                                theme: "light",
                                autoClose: 500,
                            })}
                        }
                        width={25}
                        height={25}
                        src={AddIcon}
                    />
                </Tooltip>

                <Tooltip text={t(currentUser.language, "export")}>
                    <img
                        style={{cursor: 'pointer'}}
                        onClick={isManager ? openExportModal : () => {
                            toast.error(t(currentUser.language, 'error'), {
                                position: "top-right",
                                theme: "light",
                                autoClose: 500,
                            })}
                        }
                        width={25}
                        height={25}
                        src={ExportIcon}
                    />
                </Tooltip>

                <Tooltip text={t(currentUser.language, "import")}>
                    <img
                        style={{cursor: 'pointer'}}
                        onClick={isManager ? handleImportClick : () => {
                            toast.error(t(currentUser.language, 'error'), {
                                position: "top-right",
                                theme: "light",
                                autoClose: 500,
                            })}
                        }
                        width={25}
                        height={25}
                        src={ImportIcon}
                    />
                </Tooltip>

                <Tooltip text={t(currentUser.language, "deleteAll")}>
                    <img
                        style={{cursor: 'pointer'}}
                        onClick={isManager ? openModal : () => {
                            toast.error(t(currentUser.language, 'error'), {
                                position: "top-right",
                                theme: "light",
                                autoClose: 500,
                            })}
                        }
                        width={25}
                        height={25}
                        src={DeleteAllIcon}
                    />
                </Tooltip>

            </div>

            {tempResources.length > 0 && (
                <div
                    style={{
                        height: '40px',
                        alignItems: 'center',
                        padding: '0 14px 0 14px',
                        borderRadius: '15px',
                        display: 'flex',
                        gap: '35px',
                        marginBottom: '20px',
                        marginLeft: '38px',
                        background: '#f1f3f5'
                    }}
                >
                    <Tooltip text={t(currentUser.language, "showChanges") + ` (${tempResources.length})`}>
                        <img
                            style={{cursor: 'pointer'}}
                            onClick={showChanges}
                            width={25}
                            height={25}
                            src={OverviewIcon}
                        />
                    </Tooltip>

                    <Tooltip text={t(currentUser.language, "cancelChanges")}>
                        <img
                            style={{cursor: 'pointer'}}
                            onClick={() => {
                                setConfirmModalAction(() => deleteTempResourcesList);
                                openConfirmModal();
                            }}
                            width={25}
                            height={25}
                            src={CancelIcon}
                        />
                    </Tooltip>

                    <Tooltip text={t(currentUser.language, "publishChanges")}>
                        <img
                            style={{cursor: 'pointer'}}
                            onClick={() => {
                                setConfirmModalAction(() => publishResourcesCall);
                                openConfirmModal();
                            }}
                            width={25}
                            height={25}
                            src={PublishIcon}
                        />
                    </Tooltip>

                </div>
            )}
        </div>
    );
};

export default ResourcesButtons;
